import { Form, Input } from 'antd';
import { Button } from '@cropler/ui-kit';
import stylesModal from '../../styles/modal.module.scss';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const DevicesRenameForm = ({ t, form, onClickCancel, onClickSave }) => {
  return (
    <Form form={form} layout="vertical" requiredMark={false}>
      <Form.Item
        label={t('devices.name')}
        name="deviceName"
        rules={[
          {
            required: true,
            type: 'string',
            max: 128,
            min: 1,
            message: t('devices.namePlaceholder'),
          },
        ]}
      >
        <Input type="text" size="large" />
      </Form.Item>

      <div className={stylesModal.modalNav}>
        <Button type="secondary" onClick={onClickCancel}>
          {t('actions.cancel')}
        </Button>
        <Button type="primary" icon={<CroplerIcon name="check" />} htmlType="submit" onClick={onClickSave}>
          {t('actions.save')}
        </Button>
      </div>
    </Form>
  );
}

export default DevicesRenameForm;